import TypographyParagraph from '../typography/TypographyParagraph'
import Image from '../content/Image'
// @ts-ignore
// import { InstagramEmbed } from 'react-social-media-embed';
import { useEffect, useState } from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { type Theme } from '#app/utils/providers/themeProvider'
import { ContentTile } from '../content'
import InstagramColorImage from '#images/instagram-color.webp'

const Instagram = ({
	metadata,
	// @ts-ignore
	theme = 'light',
	asCountersign = false,
	displayEmbedContent = true,
}: {
	metadata: any
	theme: Theme | undefined
	asCountersign?: boolean
	displayEmbedContent?: boolean
}) => {
	const [instagramPost, setInstagramPost] = useState(null)
	const [instagramThumbnail, setInstagramThumbnail] = useState(null)
	const [instagramError, setInstagramError] = useState(false)
	const [isEmbedProcessed, setIsEmbedProcessed] = useState(false)
	const [requestedInstagram, setRequestedInstagram] = useState(false)
	const instagramURL = metadata.properties.url

	useEffect(() => {
		const getInstagramEmbed = async () => {
			const formData = new FormData()
			formData.append('instagramURL', instagramURL)
			try {
				const url = `/getInstagram`
				const foundEmbed = await await fetch(url, {
					method: 'POST',
					body: formData,
				})
				if (foundEmbed.status === 200) {
					const fej = await foundEmbed.json()
					if (fej.body && fej.body.html) {
						setInstagramThumbnail(fej.body.thumbnail_url)
						setInstagramPost(fej.body.html)
					} else {
						setInstagramError(true)
					}
				} else {
					setInstagramError(true)
				}
			} catch (e) {
				console.error(e)
				setInstagramError(true)
			}
		}
		if (
			URL.canParse(instagramURL) &&
			instagramPost === null &&
			instagramError === false &&
			!requestedInstagram
		) {
			setRequestedInstagram(true)
			getInstagramEmbed()
		}
	}, [instagramError, instagramPost, instagramURL])

	useEffect(() => {
		if (!isEmbedProcessed && instagramPost) {
			if (window && window.instgrm) {
				window.instgrm.Embeds.process()
				setIsEmbedProcessed(true)
			}
		}
	}, [isEmbedProcessed, instagramPost])

	return (
		<div className="flex flex-col">
			{metadata.properties.description && (
				<div
					className={`${asCountersign ? 'border-b border-textInactiveLight px-4 py-2 dark:border-textInactiveDark' : 'mb-4'}`}
				>
					<TypographyParagraph
						size="medium"
						isBold={true}
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{metadata.properties.description}
					</TypographyParagraph>
				</div>
			)}
			{displayEmbedContent &&
			instagramPost &&
			instagramURL.indexOf('reel') < 0 ? (
				<div
					id="bope"
					className={`flex max-w-[80vw] justify-start overflow-hidden ${asCountersign ? 'px-4' : ''} dark:text-textPrimaryDark`}
				>
					<div
						className="w-4/5"
						id="embed"
						dangerouslySetInnerHTML={{ __html: instagramPost }}
					/>
				</div>
			) : instagramError === false ? (
				<SkeletonTheme
					baseColor={
						theme === 'light' || theme === undefined ? '#f5f5f5' : '#383838'
					}
					highlightColor={
						theme === 'light' || theme === undefined ? '#f8f8f8' : '#212121'
					}
				>
					<Skeleton className="h-[500px] w-4/5 rounded-md" />
				</SkeletonTheme>
			) : metadata.properties.ipfsCID === '' ? (
				<a href={instagramURL} target="_blank" rel="noreferrer">
					<ContentTile
						title="Instagram"
						description={instagramURL}
						image={InstagramColorImage}
						variant="art"
						showCaret={true}
						showBorder={false}
						isVerified={true}
					/>
				</a>
			) : (
				<a href={instagramURL} target="_blank" rel="noreferrer">
					<Image
						className="w-4/5 rounded-md"
						imageUrl={instagramThumbnail || metadata.properties.ipfsCID}
						imageAlt={metadata.properties.url}
					/>
				</a>
			)}
		</div>
	)
}

export default Instagram
